import { render, staticRenderFns } from "./SelectTrim.vue?vue&type=template&id=5f7fea9c"
import script from "./SelectTrim.vue?vue&type=script&lang=js"
export * from "./SelectTrim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports